import {defaultTransformFn, dsApi} from "./DsApi";
import {Addon} from "../entities/Addon";

const addonsTags = dsApi.enhanceEndpoints({addTagTypes: ["Addons", "Addon"]});

const addonsApi = addonsTags.injectEndpoints({
    endpoints: (build) => ({
        getAddons: build.query<Addon[], void>({
            query: () => {
                return {
                    url: `addons`,
                    method: "GET",
                };
            },
            transformResponse: defaultTransformFn,
            providesTags: () => [{type: "Addons"}],
        }),
        getAddon: build.query<Addon, { addonId: string }>({
            query: (request) => {
                return {
                    url: `addons/${request.addonId}`,
                    method: "GET",
                };
            },
            transformResponse: defaultTransformFn,
            providesTags: (response, _, request) => [
                {type: "Addon", id: request.addonId},
            ],
        }),
        updateAddon: build.mutation<Addon, { id: string, name: string, description: string }>({
            query: (request) => {
                return {
                    url: `addons/${request.id}`,
                    method: "PUT",
                    data: {
                        name: request.name,
                        description: request.description,
                    },
                };
            },
            transformResponse: defaultTransformFn,
            invalidatesTags: (result, x, request) => [{type: "Addons"}, {type: "Addon", id: request.id}],
        })
    }),
    overrideExisting: false,
});

export const {useGetAddonQuery, useGetAddonsQuery, useUpdateAddonMutation} = addonsApi;
